module.exports = __webpack_public_path__ + "img/20180815_151844_209.1aa716ad.jpg";